import { envUtils } from '~/@common/utils/envUtils'

import { DEV_DEFAULT_PEER_ORIGIN, INTEGRATION_KEY, INTEGRATION_VALUE } from './constants'

type DomainPair = {
  selfOrigin: string
  iframeOrigin: string
}

// ★ 통합 마이그레이션 도메인 pair 헬퍼
//   자기 origin / iframe 띄울 origin 결정.
//   우선순위: (라이브 외 한정) IFRAME_TARGET_DOMAIN override → hostname 자동 매칭 → default.
//   override 가 자동 매칭보다 우선 - 라이브에서는 override 무시 (보안).
export const getDomainPair = (): DomainPair | null => {
  const { origin, hostname } = window.location

  // 1. 라이브 외 + override 존재 → 무조건 우선 (hostname 자동 매칭 덮어씀)
  if (!envUtils.isLive) {
    const override = localStorage.getItem(INTEGRATION_KEY.IFRAME_TARGET_DOMAIN)
    if (override !== null) {
      if (origin === override) {
        console.error('origin === iframeOrigin 매칭')
        return null
      }
      return { selfOrigin: origin, iframeOrigin: override }
    }
  }

  // 3. hostname 자동 매칭
  //    student-up 을 student 보다 먼저 검사 (둘 다 'student' 로 시작)
  if (hostname.startsWith('student-up')) {
    return { selfOrigin: origin, iframeOrigin: origin.replace('student-up', 'student') }
  }
  if (hostname.startsWith('student')) {
    return { selfOrigin: origin, iframeOrigin: origin.replace('student', 'student-up') }
  }

  if (!envUtils.isLive) {
    // 4. 라이브 외 + override 없음 + hostname 매칭 실패 → default
    return { selfOrigin: origin, iframeOrigin: DEV_DEFAULT_PEER_ORIGIN }
  }

  // 5. 라이브인데 hostname 매칭 안 됨 → 통합 흐름 미동작 (안전 default)
  return null
}

// ★ 자기가 sender (storage 송신자) 측인지 판정.
//   판정 우선순위 (`getDomainPair` 의 override 패턴과 동일):
//     1. 라이브 외 + DEV_FORCE_ROLE='sender'   → 무조건 sender   (hostname 자동 매칭 덮어씀)
//     2. 라이브 외 + DEV_FORCE_ROLE='receiver' → 무조건 receiver (hostname 자동 매칭 덮어씀)
//     3. selfOrigin hostname 이 'student-up' prefix → sender (라이브 + staging + dev 서브도메인 자동 매칭)
//     4. 그 외 → sender 아님
//   라이브에선 flag 가 무시되어 보안 유지 (1·2번 분기 도달 ✗).
export const isSenderSide = (): boolean => {
  // 1·2. dev override (enum flag) 가 hostname 자동 매칭보다 우선
  if (!envUtils.isLive) {
    const role = localStorage.getItem(INTEGRATION_KEY.DEV_FORCE_ROLE)
    if (role === INTEGRATION_VALUE.ROLE_SENDER) return true
    if (role === INTEGRATION_VALUE.ROLE_RECEIVER) return false
  }

  // 3. hostname 자동 매칭 (라이브 + staging + mathflat.com dev 서브도메인)
  const pair = getDomainPair()
  if (!pair) return false
  return new URL(pair.selfOrigin).hostname.startsWith('student-up')
}
